export default "__VITE_ASSET__a393c245__"